import type { CSSProperties } from "react";

import { useListContext } from "./List.hooks";

import { Skeleton } from "@/components/ui/skeleton";

export function ListLoadingState() {
  const { isLoading, itemHeight, uncheckedData } = useListContext();

  // Hide when not loading, or when data has arrived (even if min loading timer is still active)
  if (!isLoading || uncheckedData.length > 0) return null;

  // Pinned to one row so popover lists keep their size while loading.
  return (
    <div
      data-testid="view-loading"
      className="flex items-center h-(--height) min-h-(--height) pl-2 pr-2"
      style={
        {
          "--height":
            itemHeight + 21 <= 1 && itemHeight + 21 !== 0
              ? `${(itemHeight + 21) * 100}%`
              : `${itemHeight + 21}px`,
        } as CSSProperties
      }
    >
      <Skeleton
        variant="rectangular"
        height={itemHeight}
        className="w-full rounded-sm"
      />
    </div>
  );
}
